import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class GetCompaniesByUserId {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) {}

  async run(user_id: number): Promise<void> {
    let args = {user_id:user_id}
    let data
    try {
      this.frontend.loading_table = true
      data = await this.dispatcher.dispatch('companies_list_user', args)
    } catch(error) {
        console.error('Error during get companies by user id', error)
    }
    this.frontend.companies = data
    this.frontend.loading_table = false
  }
}